module.exports = __webpack_public_path__ + "static/media/umrah_thumb2.60f50ce4.jpg";